/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(36);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _placement = __webpack_require__(2);
	
	var _placement2 = _interopRequireDefault(_placement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	"use strict";
	
	/**
	 * 環境情報
	 */
	
	var Environment = function () {
	  function Environment(mode, akamaiHost, akamaiTagDirectory, adServerEndPoint) {
	    _classCallCheck(this, Environment);
	
	    this.mode = mode; // 実行環境文字列 local|development|staging|production
	    this.akamaiHost = akamaiHost; // (dev-|staging-| )speee-ad.akamaized.net
	    this.akamaiTagDirectory = akamaiTagDirectory; // this.akamaiHost/tag
	    this.adServerEndPoint = adServerEndPoint; // 配信サーバエンドポイント(dev-|staging-| )click.speee-ad.jp
	  }
	
	  _createClass(Environment, [{
	    key: "isLocal",
	    value: function isLocal() {
	      return this.mode === 'local';
	    }
	  }, {
	    key: "isDevelopment",
	    value: function isDevelopment() {
	      return this.mode === 'development';
	    }
	  }, {
	    key: "isStaging",
	    value: function isStaging() {
	      return this.mode === 'staging';
	    }
	  }, {
	    key: "isProduction",
	    value: function isProduction() {
	      return this.mode === 'production';
	    }
	  }, {
	    key: "isTest",
	    value: function isTest() {
	      return this.mode === 'test';
	    }
	  }, {
	    key: "getPlacementTagPath",
	    value: function getPlacementTagPath(placement, window) {
	      if (this.isLocal() || this.isTest()) {
	        return "//" + window.location.host + "/";
	      }
	      return this.akamaiTagDirectory + "/" + placement.code + "/";
	    }
	  }], [{
	    key: "create",
	    value: function create(mode) {
	      var envPrefix = '';
	      var akamaiHost = "speee-ad.akamaized.net";
	      var adServerEndPoint = "click.speee-ad.jp";
	      var adServerPath = "/v1/recwid";
	      var akamaiTagDirectory = "";
	
	      switch (mode) {
	        case 'test':
	        case 'local':
	          akamaiHost = "//dev-" + akamaiHost;
	          adServerEndPoint = "//localhost:8081" + adServerPath;
	          break;
	        case 'development':
	          envPrefix = 'dev';
	          akamaiHost = "//" + envPrefix + "-" + akamaiHost;
	          akamaiTagDirectory = akamaiHost + "/tag";
	          adServerEndPoint = "//" + envPrefix + "-" + adServerEndPoint + adServerPath;
	          break;
	        case 'staging':
	          envPrefix = 'staging';
	          akamaiHost = "//" + envPrefix + "-" + akamaiHost;
	          akamaiTagDirectory = akamaiHost + "/tag";
	          adServerEndPoint = "//" + envPrefix + "-" + adServerEndPoint + adServerPath;
	          break;
	        case 'production':
	          akamaiHost = "//" + akamaiHost;
	          akamaiTagDirectory = akamaiHost + "/tag";
	          adServerEndPoint = "//" + adServerEndPoint + adServerPath;
	          break;
	        default:
	          throw new Error("environment should be any one of [local|development|staging|production|test].");
	      }
	
	      return new Environment(mode, akamaiHost, akamaiTagDirectory, adServerEndPoint);
	    }
	  }]);
	
	  return Environment;
	}();
	
	exports.default = Environment;
	module.exports = exports["default"];

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * プレイスメント情報
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Placement = function () {
	  function Placement(id, code) {
	    _classCallCheck(this, Placement);
	
	    this.id = id; // プレイスメントID
	    this.code = code; // プレイスメントコード
	  }
	
	  _createClass(Placement, null, [{
	    key: "create",
	    value: function create(id, code) {
	      var placementId = parseInt(id);
	      if (isNaN(placementId)) {
	        throw new Error('placementId parse failed');
	      }
	
	      return new Placement(placementId, code);
	    }
	  }]);
	
	  return Placement;
	}();
	
	exports.default = Placement;
	module.exports = exports["default"];

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  placementSettingBinder: "${__placement_setting__}",
	  uzouDebugURLParamKey: "uzou_debug",
	  uzouDebugURLParam: "1",
	  articleResponseType: "article_response",
	  adResponseType: "ad_response",
	  mediaAdResponseType: "media_ad_response"
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ravenJs = __webpack_require__(23);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _ravenOptions = __webpack_require__(17);
	
	var _ravenOptions2 = _interopRequireDefault(_ravenOptions);
	
	var _environment = __webpack_require__(1);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _placementSetting = __webpack_require__(6);
	
	var _placementSetting2 = _interopRequireDefault(_placementSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ロガー
	 * 本番ではエラーをSentryへ送信する
	 */
	var Logger = function () {
	  function Logger(environment, sentryLogger) {
	    _classCallCheck(this, Logger);
	
	    this.environment = environment;
	    this.sentryLogger = sentryLogger;
	  }
	
	  _createClass(Logger, [{
	    key: "info",
	    value: function info(message) {
	      // 本番以外ではコンソールに表示
	      if (!this.environment.isProduction()) {
	        console.log(message);
	      }
	    }
	  }, {
	    key: "error",
	    value: function error(e) {
	      if (this.sentryLogger != null) {
	        this.sentryLogger.captureException(e, { tags: { scope: 'uzou' } }); // タグ
	      }
	      // 本番以外ではコンソールに表示
	      if (!this.environment.isProduction()) {
	        console.error(e);
	      }
	    }
	  }], [{
	    key: "getInstance",
	    value: function getInstance(environment, placementSetting, window) {
	      var sentryLogger = null;
	      try {
	        if (placementSetting.sentryDSN) {
	          sentryLogger = _ravenJs2.default.config(placementSetting.sentryDSN, _ravenOptions2.default).install();
	        }
	      } catch (e) {
	        console.error(e);
	      }
	
	      var logger = new Logger(environment, sentryLogger);
	
	      // Singleton
	      Logger.getInstance = function () {
	        return logger;
	      };
	
	      return logger;
	    }
	  }]);
	
	  return Logger;
	}();
	
	exports.default = Logger;
	module.exports = exports["default"];

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * 端末情報
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Device = function () {
	  function Device(code) {
	    _classCallCheck(this, Device);
	
	    this.code = code; // 端末コード
	  }
	
	  /**
	   * PC識別コード
	   * @returns {number}
	   */
	
	
	  _createClass(Device, [{
	    key: 'isPC',
	
	
	    /**
	     * PC判定
	     * @returns {boolean}
	     */
	    value: function isPC() {
	      return this.code === Device.pcCode();
	    }
	
	    /**
	     * SP判定
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isSP',
	    value: function isSP() {
	      return this.code === Device.spCode();
	    }
	  }], [{
	    key: 'pcCode',
	    value: function pcCode() {
	      return 1;
	    }
	
	    /**
	     * SP識別コード
	     * @returns {number}
	     */
	
	  }, {
	    key: 'spCode',
	    value: function spCode() {
	      return 2;
	    }
	
	    /**
	     * iphone, ipod, ipad, androidがuaの文字列に含まれていなければPC = 1、含まれていなければSP = 2を返す。
	     * @return {Device}
	     */
	
	  }, {
	    key: 'create',
	    value: function create(window) {
	      var ua = window.navigator.userAgent.toLowerCase();
	      var code = ua.indexOf('iphone') === -1 && ua.indexOf('ipod') === -1 && ua.indexOf('ipad') === -1 && ua.indexOf('android') === -1 && ua.indexOf('mobile') === -1 ? Device.pcCode() : Device.spCode();
	      return new Device(code);
	    }
	  }]);
	
	  return Device;
	}();
	
	exports.default = Device;
	module.exports = exports['default'];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _environment = __webpack_require__(1);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	"use strict";
	
	/**
	 * gulp経由でsetting.jsonから渡される外部情報
	 */
	
	var PlacementSetting = function () {
	  function PlacementSetting(placementCode, placementId, headerText, publishedAtFmt, environment, sentryDSN) {
	    _classCallCheck(this, PlacementSetting);
	
	    this.placementCode = placementCode; // プレイスメントコード
	    this.placementId = placementId; // プレイスメントID
	    this.headerText = headerText; // ヘッダーテキスト
	    this.publishedAtFmt = publishedAtFmt; // 記事作成日表示フォーマット
	    this.environment = environment; // 実行環境文字列 local|development|staging|production
	    this.sentryDSN = sentryDSN; // sentryDSN
	  }
	
	  _createClass(PlacementSetting, null, [{
	    key: "create",
	    value: function create(json) {
	      try {
	        PlacementSetting.validate(json);
	        return new PlacementSetting(json.placement_code, json.placement_id, json.header_text, json.published_at_fmt, json.environment, json.sentryDSN);
	      } catch (e) {
	        throw e;
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(json) {
	      // 必須パラメータ
	      if (!json.placement_code) {
	        throw new Error("PlacementSetting:can't load json.placement_code");
	      }
	
	      if (!json.placement_id) {
	        throw new Error("PlacementSetting:can't load json.placement_id");
	      }
	
	      if (!json.environment) {
	        throw new Error("PlacementSetting:can't load json.environment");
	      }
	
	      // 空文字でもOKなパラメータ
	      if (!('header_text' in json)) {
	        throw new Error("PlacementSetting:can't load json.header_text");
	      }
	
	      if (!('published_at_fmt' in json)) {
	        throw new Error("PlacementSetting:can't load published_at_fmt.placement_code");
	      }
	
	      if (!('sentryDSN' in json)) {
	        throw new Error("PlacementSetting:can't load json.environment");
	      }
	    }
	  }]);
	
	  return PlacementSetting;
	}();
	
	exports.default = PlacementSetting;
	module.exports = exports["default"];

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * ユーザ情報
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var User = function () {
	  function User(uuid) {
	    _classCallCheck(this, User);
	
	    this.uuid = uuid; // UUID
	  }
	
	  _createClass(User, null, [{
	    key: "create",
	    value: function create(uuid) {
	      return new User(uuid);
	    }
	  }]);
	
	  return User;
	}();
	
	exports.default = User;
	module.exports = exports["default"];

/***/ },
/* 8 */,
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Inview関連オブジェクト
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WidgetInview = function WidgetInview() {
	  _classCallCheck(this, WidgetInview);
	
	  this.startEnable = false; // インビュー開始フラグ
	  this.isDone = false; // インビュー計測完了フラグ
	  this.requestURL = ""; // インビューリクエストURL
	  this.pointPixel = 0; // インビュー計測ポイント
	};
	
	exports.default = WidgetInview;
	module.exports = exports["default"];

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * フレーム内からフレーム外へデータを渡すDTO
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InnerToOuterDto = function () {
	  function InnerToOuterDto(widgetId, uuid, widgetHeight, inviewRequestURL, inviewPointPixel) {
	    _classCallCheck(this, InnerToOuterDto);
	
	    this.widgetId = widgetId;
	    this.uuid = uuid;
	    this.widgetHeight = widgetHeight;
	    this.inviewRequestURL = inviewRequestURL;
	    this.inviewPointPixel = inviewPointPixel;
	  }
	
	  _createClass(InnerToOuterDto, [{
	    key: "toJsonString",
	
	
	    /**
	     * オブジェクトをJson文字列にして返却
	     * @returns {string}
	     */
	    value: function toJsonString() {
	      var json = {
	        widgetId: this.widgetId,
	        uuid: this.uuid,
	        widgetHeight: this.widgetHeight,
	        inviewRequestURL: this.inviewRequestURL,
	        inviewPointPixel: this.inviewPointPixel
	      };
	      return encodeURIComponent(JSON.stringify(json));
	    }
	  }], [{
	    key: "create",
	    value: function create(widgetId, uuid, widgetHeight, inviewRequestURL, inviewPointPixel) {
	      return new InnerToOuterDto(widgetId, uuid, widgetHeight, inviewRequestURL, inviewPointPixel);
	    }
	
	    /**
	     * Json文字列からオブジェクトを生成
	     * @param string
	     * @returns {InnerToOuterDto}
	     */
	
	  }, {
	    key: "fromStringJson",
	    value: function fromStringJson(string) {
	      try {
	        var json = JSON.parse(decodeURIComponent(string));
	        return new InnerToOuterDto(json.widgetId, json.uuid, json.widgetHeight, json.inviewRequestURL, json.inviewPointPixel);
	      } catch (e) {
	        throw new Error("json parse error. value:" + decodeURIComponent(string));
	      }
	    }
	  }]);
	
	  return InnerToOuterDto;
	}();
	
	exports.default = InnerToOuterDto;
	module.exports = exports["default"];

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * フレーム外からフレーム内へデータを渡すDTO
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OuterToInnerDto = function () {
	  function OuterToInnerDto(widgetId, url, referer, deviceCode, uuid) {
	    _classCallCheck(this, OuterToInnerDto);
	
	    this.widgetId = widgetId;
	    this.url = url;
	    this.referer = referer;
	    this.deviceCode = deviceCode;
	    this.uuid = uuid;
	  }
	
	  /**
	   * article.htmlのクエリパラメータに設定するkey
	   * @return {string}
	   */
	
	
	  _createClass(OuterToInnerDto, [{
	    key: "toJsonString",
	
	
	    /**
	     * オブジェクトをJson文字列にして返却
	     * @return {string}
	     */
	    value: function toJsonString() {
	      var json = {
	        widgetId: this.widgetId,
	        url: this.url,
	        referer: this.referer,
	        deviceCode: this.deviceCode,
	        uuid: this.uuid
	      };
	      return encodeURIComponent(JSON.stringify(json));
	    }
	  }], [{
	    key: "QUERY_KEY",
	    value: function QUERY_KEY() {
	      return "dto";
	    }
	
	    /**
	     * Json文字列からオブジェクトを生成
	     * @param string
	     * @returns {OuterToInnerDto}
	     */
	
	  }, {
	    key: "fromStringJson",
	    value: function fromStringJson(string) {
	      try {
	        var json = JSON.parse(decodeURIComponent(string));
	        return new OuterToInnerDto(json.widgetId, json.url, json.referer, json.deviceCode, json.uuid);
	      } catch (e) {
	        throw e;
	      }
	    }
	  }]);
	
	  return OuterToInnerDto;
	}();
	
	exports.default = OuterToInnerDto;
	module.exports = exports["default"];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _urlUtil = __webpack_require__(30);
	
	var _urlUtil2 = _interopRequireDefault(_urlUtil);
	
	var _outerWidget = __webpack_require__(13);
	
	var _outerWidget2 = _interopRequireDefault(_outerWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * DIコンテナ
	 */
	var OuterDIContainer = function () {
	  function OuterDIContainer() {
	    _classCallCheck(this, OuterDIContainer);
	  }
	
	  _createClass(OuterDIContainer, [{
	    key: "handleResizeEvent",
	
	
	    /**
	     * サイドバーが存在するメディアでbodyなどグローバル領域の要素の縦横幅を元にWidgetのサイズを決められるようにする
	     * @param widget
	     * @param window
	     * @param doc
	     */
	    value: function handleResizeEvent(widget, window, doc) {}
	
	    /**
	     * 記事URL取得関数
	     * デフォルト window.location.href
	     * 無限スクロールでwindow.location.href以外から記事URLを組み立てる
	     * @param window
	     * @param iframeParentDiv
	     * @returns {string}
	     */
	
	  }, {
	    key: "getURLFunction",
	    value: function getURLFunction(window, iframeParentDiv) {
	      return _urlUtil2.default.fixedEncodeURIComponent(window.location.href);
	    }
	  }], [{
	    key: "getInstance",
	    value: function getInstance() {
	      var diContainer = new OuterDIContainer();
	      // Singleton
	      OuterDIContainer.getInstance = function () {
	        return diContainer;
	      };
	      return diContainer;
	    }
	  }]);
	
	  return OuterDIContainer;
	}();
	
	exports.default = OuterDIContainer;
	module.exports = exports["default"];

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _outerToInnerDto = __webpack_require__(11);
	
	var _outerToInnerDto2 = _interopRequireDefault(_outerToInnerDto);
	
	var _innerToOuterDto = __webpack_require__(10);
	
	var _innerToOuterDto2 = _interopRequireDefault(_innerToOuterDto);
	
	var _placement = __webpack_require__(2);
	
	var _placement2 = _interopRequireDefault(_placement);
	
	var _environment = __webpack_require__(1);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _device = __webpack_require__(5);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _user = __webpack_require__(7);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _outerWidgetAttribute = __webpack_require__(27);
	
	var _outerWidgetAttribute2 = _interopRequireDefault(_outerWidgetAttribute);
	
	var _widgetInview = __webpack_require__(9);
	
	var _widgetInview2 = _interopRequireDefault(_widgetInview);
	
	var _logger = __webpack_require__(4);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OuterWidget = function () {
	  function OuterWidget(id, environment, device, placement, url, referer, user, attribute, inview) {
	    _classCallCheck(this, OuterWidget);
	
	    this.id = id; // widget親Div.id
	    this.environment = environment; // Environment
	    this.device = device; // Device
	    this.placement = placement; // Placement
	    this.url = url; // 記事URL
	    this.referer = referer; // 記事リファラ
	    this.user = user; // User
	    this.attribute = attribute; // OuterWidgetAttribute
	    this.inview = inview; // WidgetInview
	  }
	
	  _createClass(OuterWidget, [{
	    key: "iframeId",
	    value: function iframeId() {
	      return this.id + "-frame";
	    }
	
	    /**
	     * WidgetのIframeElementを作成
	     * @param window
	     * @param doc
	     * @returns {Element}
	     */
	
	  }, {
	    key: "toIFrameElement",
	    value: function toIFrameElement(window, doc) {
	      var iframe = doc.createElement('iframe');
	      iframe.id = this.iframeId();
	      iframe.style.height = this.attribute.height;
	      iframe.src = this.environment.getPlacementTagPath(this.placement, window) + "article.html?" + _outerToInnerDto2.default.QUERY_KEY() + "=" + this.toDto().toJsonString();
	
	      return iframe;
	    }
	
	    /**
	     * フレーム内からのPostMessageを受け取りIframe要素の高さを再設定する
	     * @param doc
	     */
	
	  }, {
	    key: "resizeHeight",
	    value: function resizeHeight(doc) {
	      var iframeParentDiv = doc.getElementById(this.id);
	      var iframe = doc.getElementById(this.iframeId());
	      var height = this.attribute.height / this.attribute.mediaZoom;
	      if (height) {
	        iframeParentDiv.style.height = height + "px";
	        iframe.style.height = height + "px";
	      } else {
	        iframeParentDiv.style.display = 'none';
	        iframe.style.display = 'none';
	      }
	    }
	
	    /**
	     * Iframe要素の横幅を再設定する
	     * @param doc
	     * @param width
	     */
	
	  }, {
	    key: "resizeWidth",
	    value: function resizeWidth(doc, width) {
	      var iframeParentDiv = doc.getElementById(this.id);
	      var iframe = doc.getElementById(this.iframeId());
	      var w = width / this.attribute.mediaZoom;
	      if (w) {
	        iframeParentDiv.style.width = width + "px";
	        iframe.style.width = width + "px";
	      }
	    }
	
	    /**
	     * Inview計測
	     * @param window
	     * @param doc
	     */
	
	  }, {
	    key: "measureInview",
	    value: function measureInview(window, doc) {
	      if (!this.isInviewPreparation(doc)) {
	        return;
	      }
	
	      var adTagDiv = doc.getElementById(this.id);
	      // なんらかの理由でWidgetの親Divが取得出来なくなった場合はインビュー計測を行わない
	      if (!adTagDiv) {
	        this.inview.isDone = true;
	        window.Uzou.logger.error(new Error("can not measure widget inview."));
	        return;
	      }
	
	      var windowInnerHeight = window.innerHeight; // 画面サイズを取得
	      // Inviewの仕様はページ上部から見てWidget全体の30%以上を閲覧した時
	      // Iframe親Divのtop絶対座標にpointPixel=widget.height*0.3を足す
	      var scrolled = adTagDiv.getBoundingClientRect().top + this.inview.pointPixel;
	      // ブラウザの表示域がIframeのTop + Inview判定Pixel数を上回ったらInviewフラグを立てる
	      if (windowInnerHeight > scrolled) {
	        this.inview.isDone = true;
	        // Inview発火scriptTagをiframe親Div直下にappendすることでリクエストを送る
	        var script = doc.createElement('script');
	        script.async = true;
	        script.type = "text/javascript";
	        script.src = this.inview.requestURL;
	        adTagDiv.appendChild(script);
	      }
	    }
	
	    /**
	     * Inview計測対象フィルター
	     * @returns {boolean}
	     */
	
	  }, {
	    key: "isInviewPreparation",
	    value: function isInviewPreparation() {
	      return this.attribute.height > 0 && // ウィジェット表示している
	      this.inview && // inviewオブジェクトが存在している
	      this.inview.startEnable && // inview開始フラグが設定されている
	      this.inview.isDone === false && // inviewが完了していない
	      this.inview.requestURL.length > 0 && // inviewのリクエストURLが設定されている
	      this.inview.pointPixel > 0 // inview計測ポイントが設定されている
	      ;
	    }
	
	    /**
	     * OuterWidget => OuterToInnerDto変換
	     * @returns {OuterToInnerDto}
	     */
	
	  }, {
	    key: "toDto",
	    value: function toDto() {
	      return new _outerToInnerDto2.default(this.id, this.url, this.referer, this.device.code, this.user.uuid);
	    }
	
	    /**
	     * InnerToOuterDtoから送られてきた値をWidgetにセット
	     * @param innerToOuterDto
	     */
	
	  }, {
	    key: "receiveDto",
	    value: function receiveDto(innerToOuterDto) {
	      this.inview.startEnable = true;
	      this.attribute.height = innerToOuterDto.widgetHeight;
	      this.user.uuid = innerToOuterDto.uuid;
	      this.inview.requestURL = innerToOuterDto.inviewRequestURL;
	      this.inview.pointPixel = innerToOuterDto.inviewPointPixel;
	    }
	  }], [{
	    key: "create",
	    value: function create(placement, environment, device, user, url, referrer, attribute, inview, uzouWidgetsLength) {
	      var widgetId = "uz-" + placement.code + "-" + uzouWidgetsLength;
	
	      return new OuterWidget(widgetId, environment, device, placement, url, referrer, user, attribute, inview);
	    }
	  }]);
	
	  return OuterWidget;
	}();
	
	exports.default = OuterWidget;
	module.exports = exports["default"];

/***/ },
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  tags: {
	    adtag: 'v1.4'
	  },
	  autoBreadcrumbs: {
	    'xhr': false, // XMLHttpRequest
	    'console': false, // console logging
	    'dom': false, // DOM interactions, i.e. clicks/typing
	    'location': false // url changes, including pushState/popState
	  },
	  ignoreErrors: [
	  // Random plugins/extensions
	  'top.GLOBALS',
	  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
	  'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', 'Can\'t find variable: ZiteReader', 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose',
	  // Facebook borked
	  'fb_xd_fragment',
	  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
	  // reduce this. (thanks @acdha)
	  // See http://stackoverflow.com/questions/4113268
	  'bmi_SafeAddOnload', 'EBCallBackMessageReceived',
	  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
	  'conduitPage',
	  // IE Error. (The cause is unknown)
	  'Can\'t execute code from a freed script', '解放されたスクリプトからコードを実行できません'],
	  // ignoreUrls: [
	  //   // Facebook flakiness
	  //   /graph\.facebook\.com/i,
	  //   // Facebook blocked
	  //   /connect\.facebook\.net\/en_US\/all\.js/i,
	  //   // Woopra flakiness
	  //   /eatdifferent\.com\.woopra-ns\.com/i,
	  //   /static\.woopra\.com\/js\/woopra\.js/i,
	  //   // Chrome extensions
	  //   /extensions\//i,
	  //   /^chrome:\/\//i,
	  //   // Other plugins
	  //   /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
	  //   /webappstoolbarba\.texthelp\.com\//i,
	  //   /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
	  // ]
	  // UZOUのjsだけをエラー収集の対象にする
	  // TODO: ローカル実行時でもエラー収集の対象になるようにファイル名を直接指定しているが、
	  // ファイルが増えた際に望ましくないので後日別の方式に変更する。
	  // (config.jsonにakamaiのパスを移行する等の改修もその際に行う)
	  whitelistUrls: [/outer-frame\.min\.js/, /inner-frame\.min\.js/]
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(3);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * URLクエリパラメータユーティリティクラス
	 */
	var URLParamUtil = function () {
	  function URLParamUtil() {
	    _classCallCheck(this, URLParamUtil);
	  }
	
	  _createClass(URLParamUtil, null, [{
	    key: "getURLParamByKey",
	
	
	    /**
	     * クエリパラメータから指定したkeyの値を取得
	     * @param window
	     * @param paramKey
	     * @returns {string}
	     */
	    value: function getURLParamByKey(window, paramKey) {
	      var ret = "";
	
	      var params = window.location.search.substring(1).split('&');
	      for (var i = 0; i < params.length; i++) {
	        var keySearch = params[i].search(/=/);
	
	        var key = '';
	        if (keySearch != -1) {
	          key = params[i].slice(0, keySearch);
	        }
	
	        if (key != '' && key === paramKey) {
	          ret = params[i].slice(params[i].indexOf('=', 0) + 1);
	          break;
	        }
	      }
	      return ret;
	    }
	
	    /**
	     * ウィジェットが表示されている記事のクエリパラメータにuzou_debug=1がついている場合リハーサル配信とする
	     * リハーサル配信 = placement.status = 0でもウィジェット表示、impressionを発生させない
	     * @param window
	     * @returns {boolean}
	     */
	
	  }, {
	    key: "isRehearsal",
	    value: function isRehearsal(window) {
	      return URLParamUtil.getURLParamByKey(window.top, _constants2.default.uzouDebugURLParamKey) === _constants2.default.uzouDebugURLParam;
	    }
	
	    /**
	     * uzou_debug=1文字列を返す。
	     * @returns {string}
	     */
	
	  }, {
	    key: "getUzouDebugQuery",
	    value: function getUzouDebugQuery() {
	      return _constants2.default.uzouDebugURLParamKey + "=" + _constants2.default.uzouDebugURLParam;
	    }
	  }]);
	
	  return URLParamUtil;
	}();
	
	exports.default = URLParamUtil;
	module.exports = exports["default"];

/***/ },
/* 19 */
/***/ function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	function RavenConfigError(message) {
	    this.name = 'RavenConfigError';
	    this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	var wrapMethod = function(console, level, callback) {
	    var originalConsoleLevel = console[level];
	    var originalConsole = console;
	
	    if (!(level in console)) {
	        return;
	    }
	
	    var sentryLevel = level === 'warn'
	        ? 'warning'
	        : level;
	
	    console[level] = function () {
	        var args = [].slice.call(arguments);
	
	        var msg = '' + args.join(' ');
	        var data = {level: sentryLevel, logger: 'console', extra: {'arguments': args}};
	        callback && callback(msg, data);
	
	        // this fails for some browsers. :(
	        if (originalConsoleLevel) {
	            // IE9 doesn't allow calling apply on console functions directly
	            // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	            Function.prototype.apply.call(
	                originalConsoleLevel,
	                originalConsole,
	                args
	            );
	        }
	    };
	};
	
	module.exports = {
	    wrapMethod: wrapMethod
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false, __DEV__:false*/
	'use strict';
	
	var TraceKit = __webpack_require__(24);
	var RavenConfigError = __webpack_require__(20);
	var stringify = __webpack_require__(19);
	
	var wrapConsoleMethod = __webpack_require__(21).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	    return +new Date();
	}
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	var _document = _window.document;
	var _navigator = _window.navigator;
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	    this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	    // Raven can run in contexts where there's no document (react-native)
	    this._hasDocument = !isUndefined(_document);
	    this._hasNavigator = !isUndefined(_navigator);
	    this._lastCapturedException = null;
	    this._lastData = null;
	    this._lastEventId = null;
	    this._globalServer = null;
	    this._globalKey = null;
	    this._globalProject = null;
	    this._globalContext = {};
	    this._globalOptions = {
	        logger: 'javascript',
	        ignoreErrors: [],
	        ignoreUrls: [],
	        whitelistUrls: [],
	        includePaths: [],
	        crossOrigin: 'anonymous',
	        collectWindowErrors: true,
	        maxMessageLength: 0,
	        stackTraceLimit: 50,
	        autoBreadcrumbs: true
	    };
	    this._ignoreOnError = 0;
	    this._isRavenInstalled = false;
	    this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	    // capture references to window.console *and* all its methods first
	    // before the console plugin has a chance to monkey patch
	    this._originalConsole = _window.console || {};
	    this._originalConsoleMethods = {};
	    this._plugins = [];
	    this._startTime = now();
	    this._wrappedBuiltIns = [];
	    this._breadcrumbs = [];
	    this._lastCapturedEvent = null;
	    this._keypressTimeout;
	    this._location = _window.location;
	    this._lastHref = this._location && this._location.href;
	    this._resetBackoff();
	
	    for (var method in this._originalConsole) {  // eslint-disable-line guard-for-in
	      this._originalConsoleMethods[method] = this._originalConsole[method];
	    }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	    // Hardcode version string so that raven source can be loaded directly via
	    // webpack (using a build step causes webpack #1617). Grunt verifies that
	    // this value matches package.json during build.
	    //   See: https://github.com/getsentry/raven-js/issues/465
	    VERSION: '3.12.0',
	
	    debug: false,
	
	    TraceKit: TraceKit, // alias to TraceKit
	
	    /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Optional set of of global options [optional]
	     * @return {Raven}
	     */
	    config: function(dsn, options) {
	        var self = this;
	
	        if (self._globalServer) {
	                this._logDebug('error', 'Error: Raven has already been configured');
	            return self;
	        }
	        if (!dsn) return self;
	
	        var globalOptions = self._globalOptions;
	
	        // merge in options
	        if (options) {
	            each(options, function(key, value){
	                // tags and extra are special and need to be put into context
	                if (key === 'tags' || key === 'extra' || key === 'user') {
	                    self._globalContext[key] = value;
	                } else {
	                    globalOptions[key] = value;
	                }
	            });
	        }
	
	        self.setDSN(dsn);
	
	        // "Script error." is hard coded into browsers for errors that it can't read.
	        // this is the result of a script being pulled in from an external domain and CORS.
	        globalOptions.ignoreErrors.push(/^Script error\.?$/);
	        globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	        // join regexp rules into one big rule
	        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
	        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
	        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	        globalOptions.maxBreadcrumbs = Math.max(0, Math.min(globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100
	
	        var autoBreadcrumbDefaults = {
	            xhr: true,
	            console: true,
	            dom: true,
	            location: true
	        };
	
	        var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
	        if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	            autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	        } else if (autoBreadcrumbs !== false) {
	            autoBreadcrumbs = autoBreadcrumbDefaults;
	        }
	        globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	        // return for chaining
	        return self;
	    },
	
	    /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	    install: function() {
	        var self = this;
	        if (self.isSetup() && !self._isRavenInstalled) {
	            TraceKit.report.subscribe(function () {
	                self._handleOnErrorStackInfo.apply(self, arguments);
	            });
	            self._instrumentTryCatch();
	            if (self._globalOptions.autoBreadcrumbs)
	                self._instrumentBreadcrumbs();
	
	            // Install all of the plugins
	            self._drainPlugins();
	
	            self._isRavenInstalled = true;
	        }
	
	        Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
	        return this;
	    },
	
	    /*
	     * Set the DSN (can be called multiple time unlike config)
	     *
	     * @param {string} dsn The public Sentry DSN
	     */
	    setDSN: function(dsn) {
	        var self = this,
	            uri = self._parseDSN(dsn),
	          lastSlash = uri.path.lastIndexOf('/'),
	          path = uri.path.substr(1, lastSlash);
	
	        self._dsn = dsn;
	        self._globalKey = uri.user;
	        self._globalSecret = uri.pass && uri.pass.substr(1);
	        self._globalProject = uri.path.substr(lastSlash + 1);
	
	        self._globalServer = self._getGlobalServer(uri);
	
	        self._globalEndpoint = self._globalServer +
	            '/' + path + 'api/' + self._globalProject + '/store/';
	
	        // Reset backoff state since we may be pointing at a
	        // new project/server
	        this._resetBackoff();
	    },
	
	    /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	    context: function(options, func, args) {
	        if (isFunction(options)) {
	            args = func || [];
	            func = options;
	            options = undefined;
	        }
	
	        return this.wrap(options, func).apply(this, args);
	    },
	
	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	    wrap: function(options, func, _before) {
	        var self = this;
	        // 1 argument has been passed, and it's not a function
	        // so just return it
	        if (isUndefined(func) && !isFunction(options)) {
	            return options;
	        }
	
	        // options is optional
	        if (isFunction(options)) {
	            func = options;
	            options = undefined;
	        }
	
	        // At this point, we've passed along 2 arguments, and the second one
	        // is not a function either, so we'll just return the second argument.
	        if (!isFunction(func)) {
	            return func;
	        }
	
	        // We don't wanna wrap it twice!
	        try {
	            if (func.__raven__) {
	                return func;
	            }
	
	            // If this has already been wrapped in the past, return that
	            if (func.__raven_wrapper__ ){
	                return func.__raven_wrapper__ ;
	            }
	        } catch (e) {
	            // Just accessing custom props in some Selenium environments
	            // can cause a "Permission denied" exception (see raven-js#495).
	            // Bail on wrapping and return the function as-is (defers to window.onerror).
	            return func;
	        }
	
	        function wrapped() {
	            var args = [], i = arguments.length,
	                deep = !options || options && options.deep !== false;
	
	            if (_before && isFunction(_before)) {
	                _before.apply(this, arguments);
	            }
	
	            // Recursively wrap all of a function's arguments that are
	            // functions themselves.
	            while(i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	            try {
	                // Attempt to invoke user-land function
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	                //       means Raven caught an error invoking your application code. This is
	                //       expected behavior and NOT indicative of a bug with Raven.js.
	                return func.apply(this, args);
	            } catch(e) {
	                self._ignoreNextOnError();
	                self.captureException(e, options);
	                throw e;
	            }
	        }
	
	        // copy over properties of the old function
	        for (var property in func) {
	            if (hasKey(func, property)) {
	                wrapped[property] = func[property];
	            }
	        }
	        wrapped.prototype = func.prototype;
	
	        func.__raven_wrapper__ = wrapped;
	        // Signal that this function has been wrapped already
	        // for both debugging and to prevent it to being wrapped twice
	        wrapped.__raven__ = true;
	        wrapped.__inner__ = func;
	
	        return wrapped;
	    },
	
	    /*
	     * Uninstalls the global error handler.
	     *
	     * @return {Raven}
	     */
	    uninstall: function() {
	        TraceKit.report.uninstall();
	
	        this._restoreBuiltIns();
	
	        Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	        this._isRavenInstalled = false;
	
	        return this;
	    },
	
	    /*
	     * Manually capture an exception and send it over to Sentry
	     *
	     * @param {error} ex An exception to be logged
	     * @param {object} options A specific set of options for this error [optional]
	     * @return {Raven}
	     */
	    captureException: function(ex, options) {
	        // If not an Error is passed through, recall as a message instead
	        if (!isError(ex)) {
	            return this.captureMessage(ex, objectMerge({
	                trimHeadFrames: 1,
	                stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
	            }, options));
	        }
	
	        // Store the raw exception object for potential debugging and introspection
	        this._lastCapturedException = ex;
	
	        // TraceKit.report will re-raise any exception passed to it,
	        // which means you have to wrap it in try/catch. Instead, we
	        // can wrap it here and only re-raise if TraceKit.report
	        // raises an exception different from the one we asked to
	        // report on.
	        try {
	            var stack = TraceKit.computeStackTrace(ex);
	            this._handleStackInfo(stack, options);
	        } catch(ex1) {
	            if(ex !== ex1) {
	                throw ex1;
	            }
	        }
	
	        return this;
	    },
	
	    /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	    captureMessage: function(msg, options) {
	        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	        // early call; we'll error on the side of logging anything called before configuration since it's
	        // probably something you should see:
	        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
	            return;
	        }
	
	        options = options || {};
	
	        var data = objectMerge({
	            message: msg + ''  // Make sure it's actually a string
	        }, options);
	
	        if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
	            var ex;
	            // create a stack trace from this point; just trim
	            // off extra frames so they don't include this function call (or
	            // earlier Raven.js library fn calls)
	            try {
	                throw new Error(msg);
	            } catch (ex1) {
	                ex = ex1;
	            }
	
	            // null exception name so `Error` isn't prefixed to msg
	            ex.name = null;
	
	            options = objectMerge({
	                // fingerprint on msg, not stack trace (legacy behavior, could be
	                // revisited)
	                fingerprint: msg,
	                trimHeadFrames: (options.trimHeadFrames || 0) + 1
	            }, options);
	
	            var stack = TraceKit.computeStackTrace(ex);
	            var frames = this._prepareFrames(stack, options);
	            data.stacktrace = {
	                // Sentry expects frames oldest to newest
	                frames: frames.reverse()
	            }
	        }
	
	        // Fire away!
	        this._send(data);
	
	        return this;
	    },
	
	    captureBreadcrumb: function (obj) {
	        var crumb = objectMerge({
	            timestamp: now() / 1000
	        }, obj);
	
	        if (isFunction(this._globalOptions.breadcrumbCallback)) {
	            var result = this._globalOptions.breadcrumbCallback(crumb);
	
	            if (isObject(result) && !isEmptyObject(result)) {
	                crumb = result;
	            } else if (result === false) {
	                return this;
	            }
	        }
	
	        this._breadcrumbs.push(crumb);
	        if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	            this._breadcrumbs.shift();
	        }
	        return this;
	    },
	
	    addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	        var pluginArgs = [].slice.call(arguments, 1);
	
	        this._plugins.push([plugin, pluginArgs]);
	        if (this._isRavenInstalled) {
	            this._drainPlugins();
	        }
	
	        return this;
	    },
	
	    /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	    setUserContext: function(user) {
	        // Intentionally do not merge here since that's an unexpected behavior.
	        this._globalContext.user = user;
	
	        return this;
	    },
	
	    /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	    setExtraContext: function(extra) {
	        this._mergeContext('extra', extra);
	
	        return this;
	    },
	
	    /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	    setTagsContext: function(tags) {
	        this._mergeContext('tags', tags);
	
	        return this;
	    },
	
	    /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	    clearContext: function() {
	        this._globalContext = {};
	
	        return this;
	    },
	
	    /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	    getContext: function() {
	        // lol javascript
	        return JSON.parse(stringify(this._globalContext));
	    },
	
	
	    /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	    setEnvironment: function(environment) {
	        this._globalOptions.environment = environment;
	
	        return this;
	    },
	
	    /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	    setRelease: function(release) {
	        this._globalOptions.release = release;
	
	        return this;
	    },
	
	    /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	    setDataCallback: function(callback) {
	        var original = this._globalOptions.dataCallback;
	        this._globalOptions.dataCallback = isFunction(callback)
	          ? function (data) { return callback(data, original); }
	          : callback;
	
	        return this;
	    },
	
	    /*
	     * Set the breadcrumbCallback option
	     *
	     * @param {function} callback The callback to run which allows filtering
	     *                            or mutating breadcrumbs
	     * @return {Raven}
	     */
	    setBreadcrumbCallback: function(callback) {
	        var original = this._globalOptions.breadcrumbCallback;
	        this._globalOptions.breadcrumbCallback = isFunction(callback)
	          ? function (data) { return callback(data, original); }
	          : callback;
	
	        return this;
	    },
	
	    /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	    setShouldSendCallback: function(callback) {
	        var original = this._globalOptions.shouldSendCallback;
	        this._globalOptions.shouldSendCallback = isFunction(callback)
	            ? function (data) { return callback(data, original); }
	            : callback;
	
	        return this;
	    },
	
	    /**
	     * Override the default HTTP transport mechanism that transmits data
	     * to the Sentry server.
	     *
	     * @param {function} transport Function invoked instead of the default
	     *                             `makeRequest` handler.
	     *
	     * @return {Raven}
	     */
	    setTransport: function(transport) {
	        this._globalOptions.transport = transport;
	
	        return this;
	    },
	
	    /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	    lastException: function() {
	        return this._lastCapturedException;
	    },
	
	    /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	    lastEventId: function() {
	        return this._lastEventId;
	    },
	
	    /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	    isSetup: function() {
	        if (!this._hasJSON) return false;  // needs JSON support
	        if (!this._globalServer) {
	            if (!this.ravenNotConfiguredError) {
	              this.ravenNotConfiguredError = true;
	              this._logDebug('error', 'Error: Raven has not been configured.');
	            }
	            return false;
	        }
	        return true;
	    },
	
	    afterLoad: function () {
	        // TODO: remove window dependence?
	
	        // Attempt to initialize Raven on load
	        var RavenConfig = _window.RavenConfig;
	        if (RavenConfig) {
	            this.config(RavenConfig.dsn, RavenConfig.config).install();
	        }
	    },
	
	    showReportDialog: function (options) {
	        if (!_document) // doesn't work without a document (React native)
	            return;
	
	        options = options || {};
	
	        var lastEventId = options.eventId || this.lastEventId();
	        if (!lastEventId) {
	            throw new RavenConfigError('Missing eventId');
	        }
	
	        var dsn = options.dsn || this._dsn;
	        if (!dsn) {
	            throw new RavenConfigError('Missing DSN');
	        }
	
	        var encode = encodeURIComponent;
	        var qs = '';
	        qs += '?eventId=' + encode(lastEventId);
	        qs += '&dsn=' + encode(dsn);
	
	        var user = options.user || this._globalContext.user;
	        if (user) {
	            if (user.name)  qs += '&name=' + encode(user.name);
	            if (user.email) qs += '&email=' + encode(user.email);
	        }
	
	        var globalServer = this._getGlobalServer(this._parseDSN(dsn));
	
	        var script = _document.createElement('script');
	        script.async = true;
	        script.src = globalServer + '/api/embed/error-page/' + qs;
	        (_document.head || _document.body).appendChild(script);
	    },
	
	    /**** Private functions ****/
	    _ignoreNextOnError: function () {
	        var self = this;
	        this._ignoreOnError += 1;
	        setTimeout(function () {
	            // onerror should trigger before setTimeout
	            self._ignoreOnError -= 1;
	        });
	    },
	
	    _triggerEvent: function(eventType, options) {
	        // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	        var evt, key;
	
	        if (!this._hasDocument)
	            return;
	
	        options = options || {};
	
	        eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);
	
	        if (_document.createEvent) {
	            evt = _document.createEvent('HTMLEvents');
	            evt.initEvent(eventType, true, true);
	        } else {
	            evt = _document.createEventObject();
	            evt.eventType = eventType;
	        }
	
	        for (key in options) if (hasKey(options, key)) {
	            evt[key] = options[key];
	        }
	
	        if (_document.createEvent) {
	            // IE9 if standards
	            _document.dispatchEvent(evt);
	        } else {
	            // IE8 regardless of Quirks or Standards
	            // IE9 if quirks
	            try {
	                _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	            } catch(e) {
	                // Do nothing
	            }
	        }
	    },
	
	    /**
	     * Wraps addEventListener to capture UI breadcrumbs
	     * @param evtName the event name (e.g. "click")
	     * @returns {Function}
	     * @private
	     */
	    _breadcrumbEventHandler: function(evtName) {
	        var self = this;
	        return function (evt) {
	            // reset keypress timeout; e.g. triggering a 'click' after
	            // a 'keypress' will reset the keypress debounce so that a new
	            // set of keypresses can be recorded
	            self._keypressTimeout = null;
	
	            // It's possible this handler might trigger multiple times for the same
	            // event (e.g. event propagation through node ancestors). Ignore if we've
	            // already captured the event.
	            if (self._lastCapturedEvent === evt)
	                return;
	
	            self._lastCapturedEvent = evt;
	
	            // try/catch both:
	            // - accessing evt.target (see getsentry/raven-js#838, #768)
	            // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	            //   can throw an exception in some circumstances.
	            var target;
	            try {
	                target = htmlTreeAsString(evt.target);
	            } catch (e) {
	                target = '<unknown>';
	            }
	
	            self.captureBreadcrumb({
	                category: 'ui.' + evtName, // e.g. ui.click, ui.input
	                message: target
	            });
	        };
	    },
	
	    /**
	     * Wraps addEventListener to capture keypress UI events
	     * @returns {Function}
	     * @private
	     */
	    _keypressEventHandler: function() {
	        var self = this,
	            debounceDuration = 1000; // milliseconds
	
	        // TODO: if somehow user switches keypress target before
	        //       debounce timeout is triggered, we will only capture
	        //       a single breadcrumb from the FIRST target (acceptable?)
	        return function (evt) {
	            var target;
	            try {
	                target = evt.target;
	            } catch (e) {
	                // just accessing event properties can throw an exception in some rare circumstances
	                // see: https://github.com/getsentry/raven-js/issues/838
	                return;
	            }
	            var tagName = target && target.tagName;
	
	            // only consider keypress events on actual input elements
	            // this will disregard keypresses targeting body (e.g. tabbing
	            // through elements, hotkeys, etc)
	            if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
	                return;
	
	            // record first keypress in a series, but ignore subsequent
	            // keypresses until debounce clears
	            var timeout = self._keypressTimeout;
	            if (!timeout) {
	                self._breadcrumbEventHandler('input')(evt);
	            }
	            clearTimeout(timeout);
	            self._keypressTimeout = setTimeout(function () {
	                self._keypressTimeout = null;
	            }, debounceDuration);
	        };
	    },
	
	    /**
	     * Captures a breadcrumb of type "navigation", normalizing input URLs
	     * @param to the originating URL
	     * @param from the target URL
	     * @private
	     */
	    _captureUrlChange: function(from, to) {
	        var parsedLoc = parseUrl(this._location.href);
	        var parsedTo = parseUrl(to);
	        var parsedFrom = parseUrl(from);
	
	        // because onpopstate only tells you the "new" (to) value of location.href, and
	        // not the previous (from) value, we need to track the value of the current URL
	        // state ourselves
	        this._lastHref = to;
	
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	            to = parsedTo.relative;
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	            from = parsedFrom.relative;
	
	        this.captureBreadcrumb({
	            category: 'navigation',
	            data: {
	                to: to,
	                from: from
	            }
	        });
	    },
	
	    /**
	     * Install any queued plugins
	     */
	    _instrumentTryCatch: function() {
	        var self = this;
	
	        var wrappedBuiltIns = self._wrappedBuiltIns;
	
	        function wrapTimeFn(orig) {
	            return function (fn, t) { // preserve arity
	                // Make a copy of the arguments to prevent deoptimization
	                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	                var args = new Array(arguments.length);
	                for(var i = 0; i < args.length; ++i) {
	                    args[i] = arguments[i];
	                }
	                var originalCallback = args[0];
	                if (isFunction(originalCallback)) {
	                    args[0] = self.wrap(originalCallback);
	                }
	
	                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	                // also supports only two arguments and doesn't care what this is, so we
	                // can just call the original function directly.
	                if (orig.apply) {
	                    return orig.apply(this, args);
	                } else {
	                    return orig(args[0], args[1]);
	                }
	            };
	        }
	
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	        function wrapEventTarget(global) {
	            var proto = _window[global] && _window[global].prototype;
	            if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	                fill(proto, 'addEventListener', function(orig) {
	                    return function (evtName, fn, capture, secure) { // preserve arity
	                        try {
	                            if (fn && fn.handleEvent) {
	                                fn.handleEvent = self.wrap(fn.handleEvent);
	                            }
	                        } catch (err) {
	                            // can sometimes get 'Permission denied to access property "handle Event'
	                        }
	
	                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	                        // so that we don't have more than one wrapper function
	                        var before,
	                            clickHandler,
	                            keypressHandler;
	
	                        if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
	                            // NOTE: generating multiple handlers per addEventListener invocation, should
	                            //       revisit and verify we can just use one (almost certainly)
	                            clickHandler = self._breadcrumbEventHandler('click');
	                            keypressHandler = self._keypressEventHandler();
	                            before = function (evt) {
	                                // need to intercept every DOM event in `before` argument, in case that
	                                // same wrapped method is re-used for different events (e.g. mousemove THEN click)
	                                // see #724
	                                if (!evt) return;
	
	                                var eventType;
	                                try {
	                                    eventType = evt.type
	                                } catch (e) {
	                                    // just accessing event properties can throw an exception in some rare circumstances
	                                    // see: https://github.com/getsentry/raven-js/issues/838
	                                    return;
	                                }
	                                if (eventType === 'click')
	                                    return clickHandler(evt);
	                                else if (eventType === 'keypress')
	                                    return keypressHandler(evt);
	                            };
	                        }
	                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
	                    };
	                }, wrappedBuiltIns);
	                fill(proto, 'removeEventListener', function (orig) {
	                    return function (evt, fn, capture, secure) {
	                        try {
	                            fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__  : fn);
	                        } catch (e) {
	                            // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
	                        }
	                        return orig.call(this, evt, fn, capture, secure);
	                    };
	                }, wrappedBuiltIns);
	            }
	        }
	
	        fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	        fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	        if (_window.requestAnimationFrame) {
	            fill(_window, 'requestAnimationFrame', function (orig) {
	                return function (cb) {
	                    return orig(self.wrap(cb));
	                };
	            }, wrappedBuiltIns);
	        }
	
	        // event targets borrowed from bugsnag-js:
	        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	        var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	        for (var i = 0; i < eventTargets.length; i++) {
	            wrapEventTarget(eventTargets[i]);
	        }
	    },
	
	
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - XMLHttpRequests
	     *  - DOM interactions (click/typing)
	     *  - window.location changes
	     *  - console
	     *
	     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	     */
	    _instrumentBreadcrumbs: function () {
	        var self = this;
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	        var wrappedBuiltIns = self._wrappedBuiltIns;
	
	        function wrapProp(prop, xhr) {
	            if (prop in xhr && isFunction(xhr[prop])) {
	                fill(xhr, prop, function (orig) {
	                    return self.wrap(orig);
	                }); // intentionally don't track filled methods on XHR instances
	            }
	        }
	
	        if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
	            var xhrproto = XMLHttpRequest.prototype;
	            fill(xhrproto, 'open', function(origOpen) {
	                return function (method, url) { // preserve arity
	
	                    // if Sentry key appears in URL, don't capture
	                    if (isString(url) && url.indexOf(self._globalKey) === -1) {
	                        this.__raven_xhr = {
	                            method: method,
	                            url: url,
	                            status_code: null
	                        };
	                    }
	
	                    return origOpen.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	
	            fill(xhrproto, 'send', function(origSend) {
	                return function (data) { // preserve arity
	                    var xhr = this;
	
	                    function onreadystatechangeHandler() {
	                        if (xhr.__raven_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
	                            try {
	                                // touching statusCode in some platforms throws
	                                // an exception
	                                xhr.__raven_xhr.status_code = xhr.status;
	                            } catch (e) { /* do nothing */ }
	                            self.captureBreadcrumb({
	                                type: 'http',
	                                category: 'xhr',
	                                data: xhr.__raven_xhr
	                            });
	                        }
	                    }
	
	                    var props = ['onload', 'onerror', 'onprogress'];
	                    for (var j = 0; j < props.length; j++) {
	                        wrapProp(props[j], xhr);
	                    }
	
	                    if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	                        fill(xhr, 'onreadystatechange', function (orig) {
	                            return self.wrap(orig, undefined, onreadystatechangeHandler);
	                        } /* intentionally don't track this instrumentation */);
	                    } else {
	                        // if onreadystatechange wasn't actually set by the page on this xhr, we
	                        // are free to set our own and capture the breadcrumb
	                        xhr.onreadystatechange = onreadystatechangeHandler;
	                    }
	
	                    return origSend.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	        }
	
	        if (autoBreadcrumbs.xhr && 'fetch' in _window) {
	            fill(_window, 'fetch', function(origFetch) {
	                return function (fn, t) { // preserve arity
	                    // Make a copy of the arguments to prevent deoptimization
	                    // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	                    var args = new Array(arguments.length);
	                    for(var i = 0; i < args.length; ++i) {
	                        args[i] = arguments[i];
	                    }
	
	                    var method = 'GET';
	
	                    if (args[1] && args[1].method) {
	                        method = args[1].method;
	                    }
	
	                    var fetchData = {
	                        method: method,
	                        url: args[0],
	                        status_code: null
	                    };
	
	                    self.captureBreadcrumb({
	                        type: 'http',
	                        category: 'fetch',
	                        data: fetchData
	                    });
	
	                    return origFetch.apply(this, args).then(function (response) {
	                        fetchData.status_code = response.status;
	
	                        return response;
	                    });
	                };
	            }, wrappedBuiltIns);
	        }
	
	        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	        // to the document. Do this before we instrument addEventListener.
	        if (autoBreadcrumbs.dom && this._hasDocument) {
	            if (_document.addEventListener) {
	                _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	                _document.addEventListener('keypress', self._keypressEventHandler(), false);
	            }
	            else {
	                // IE8 Compatibility
	                _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	                _document.attachEvent('onkeypress', self._keypressEventHandler());
	            }
	        }
	
	        // record navigation (URL) changes
	        // NOTE: in Chrome App environment, touching history.pushState, *even inside
	        //       a try/catch block*, will cause Chrome to output an error to console.error
	        // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	        var chrome = _window.chrome;
	        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	        var hasPushState = !isChromePackagedApp && _window.history && history.pushState;
	        if (autoBreadcrumbs.location && hasPushState) {
	            // TODO: remove onpopstate handler on uninstall()
	            var oldOnPopState = _window.onpopstate;
	            _window.onpopstate = function () {
	                var currentHref = self._location.href;
	                self._captureUrlChange(self._lastHref, currentHref);
	
	                if (oldOnPopState) {
	                    return oldOnPopState.apply(this, arguments);
	                }
	            };
	
	            fill(history, 'pushState', function (origPushState) {
	                // note history.pushState.length is 0; intentionally not declaring
	                // params to preserve 0 arity
	                return function (/* state, title, url */) {
	                    var url = arguments.length > 2 ? arguments[2] : undefined;
	
	                    // url argument is optional
	                    if (url) {
	                        // coerce to string (this is what pushState does)
	                        self._captureUrlChange(self._lastHref, url + '');
	                    }
	
	                    return origPushState.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	        }
	
	        if (autoBreadcrumbs.console && 'console' in _window && console.log) {
	            // console
	            var consoleMethodCallback = function (msg, data) {
	                self.captureBreadcrumb({
	                    message: msg,
	                    level: data.level,
	                    category: 'console'
	                });
	            };
	
	            each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
	                wrapConsoleMethod(console, level, consoleMethodCallback);
	            });
	        }
	
	    },
	
	    _restoreBuiltIns: function () {
	        // restore any wrapped builtins
	        var builtin;
	        while (this._wrappedBuiltIns.length) {
	            builtin = this._wrappedBuiltIns.shift();
	
	            var obj = builtin[0],
	              name = builtin[1],
	              orig = builtin[2];
	
	            obj[name] = orig;
	        }
	    },
	
	    _drainPlugins: function() {
	        var self = this;
	
	        // FIX ME TODO
	        each(this._plugins, function(_, plugin) {
	            var installer = plugin[0];
	            var args = plugin[1];
	            installer.apply(self, [self].concat(args));
	        });
	    },
	
	    _parseDSN: function(str) {
	        var m = dsnPattern.exec(str),
	            dsn = {},
	            i = 7;
	
	        try {
	            while (i--) dsn[dsnKeys[i]] = m[i] || '';
	        } catch(e) {
	            throw new RavenConfigError('Invalid DSN: ' + str);
	        }
	
	        if (dsn.pass && !this._globalOptions.allowSecretKey) {
	            throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
	        }
	
	        return dsn;
	    },
	
	    _getGlobalServer: function(uri) {
	        // assemble the endpoint from the uri pieces
	        var globalServer = '//' + uri.host +
	            (uri.port ? ':' + uri.port : '');
	
	        if (uri.protocol) {
	            globalServer = uri.protocol + ':' + globalServer;
	        }
	        return globalServer;
	    },
	
	    _handleOnErrorStackInfo: function() {
	        // if we are intentionally ignoring errors via onerror, bail out
	        if (!this._ignoreOnError) {
	            this._handleStackInfo.apply(this, arguments);
	        }
	    },
	
	    _handleStackInfo: function(stackInfo, options) {
	        var frames = this._prepareFrames(stackInfo, options);
	
	        this._triggerEvent('handle', {
	            stackInfo: stackInfo,
	            options: options
	        });
	
	        this._processException(
	            stackInfo.name,
	            stackInfo.message,
	            stackInfo.url,
	            stackInfo.lineno,
	            frames,
	            options
	        );
	    },
	
	    _prepareFrames: function(stackInfo, options) {
	        var self = this;
	        var frames = [];
	        if (stackInfo.stack && stackInfo.stack.length) {
	            each(stackInfo.stack, function(i, stack) {
	                var frame = self._normalizeFrame(stack);
	                if (frame) {
	                    frames.push(frame);
	                }
	            });
	
	            // e.g. frames captured via captureMessage throw
	            if (options && options.trimHeadFrames) {
	                for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
	                    frames[j].in_app = false;
	                }
	            }
	        }
	        frames = frames.slice(0, this._globalOptions.stackTraceLimit);
	        return frames;
	    },
	
	
	    _normalizeFrame: function(frame) {
	        if (!frame.url) return;
	
	        // normalize the frames data
	        var normalized = {
	            filename:   frame.url,
	            lineno:     frame.line,
	            colno:      frame.column,
	            'function': frame.func || '?'
	        };
	
	        normalized.in_app = !( // determine if an exception came from outside of our app
	            // first we check the global includePaths list.
	            !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
	            // Now we check for fun, if the function name is Raven or TraceKit
	            /(Raven|TraceKit)\./.test(normalized['function']) ||
	            // finally, we do a last ditch effort and check for raven.min.js
	            /raven\.(min\.)?js$/.test(normalized.filename)
	        );
	
	        return normalized;
	    },
	
	    _processException: function(type, message, fileurl, lineno, frames, options) {
	        var stacktrace;
	        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(message)) return;
	
	        message += '';
	
	        if (frames && frames.length) {
	            fileurl = frames[0].filename || fileurl;
	            // Sentry expects frames oldest to newest
	            // and JS sends them as newest to oldest
	            frames.reverse();
	            stacktrace = {frames: frames};
	        } else if (fileurl) {
	            stacktrace = {
	                frames: [{
	                    filename: fileurl,
	                    lineno: lineno,
	                    in_app: true
	                }]
	            };
	        }
	
	        if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) return;
	        if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) return;
	
	        var data = objectMerge({
	            // sentry.interfaces.Exception
	            exception: {
	                values: [{
	                    type: type,
	                    value: message,
	                    stacktrace: stacktrace
	                }]
	            },
	            culprit: fileurl
	        }, options);
	
	        // Fire away!
	        this._send(data);
	    },
	
	    _trimPacket: function(data) {
	        // For now, we only want to truncate the two different messages
	        // but this could/should be expanded to just trim everything
	        var max = this._globalOptions.maxMessageLength;
	        if (data.message) {
	            data.message = truncate(data.message, max);
	        }
	        if (data.exception) {
	            var exception = data.exception.values[0];
	            exception.value = truncate(exception.value, max);
	        }
	
	        return data;
	    },
	
	    _getHttpData: function() {
	        if (!this._hasNavigator && !this._hasDocument) return;
	        var httpData = {};
	
	        if (this._hasNavigator && _navigator.userAgent) {
	            httpData.headers = {
	              'User-Agent': navigator.userAgent
	            };
	        }
	
	        if (this._hasDocument) {
	            if (_document.location && _document.location.href) {
	                httpData.url = _document.location.href;
	            }
	            if (_document.referrer) {
	                if (!httpData.headers) httpData.headers = {};
	                httpData.headers.Referer = _document.referrer;
	            }
	        }
	
	        return httpData;
	    },
	
	    _resetBackoff: function() {
	        this._backoffDuration = 0;
	        this._backoffStart = null;
	    },
	
	    _shouldBackoff: function() {
	        return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
	    },
	
	    /**
	     * Returns true if the in-process data payload matches the signature
	     * of the previously-sent data
	     *
	     * NOTE: This has to be done at this level because TraceKit can generate
	     *       data from window.onerror WITHOUT an exception object (IE8, IE9,
	     *       other old browsers). This can take the form of an "exception"
	     *       data object with a single frame (derived from the onerror args).
	     */
	    _isRepeatData: function (current) {
	        var last = this._lastData;
	
	        if (!last ||
	            current.message !== last.message || // defined for captureMessage
	            current.culprit !== last.culprit)   // defined for captureException/onerror
	            return false;
	
	        // Stacktrace interface (i.e. from captureMessage)
	        if (current.stacktrace || last.stacktrace) {
	            return isSameStacktrace(current.stacktrace, last.stacktrace);
	        }
	        // Exception interface (i.e. from captureException/onerror)
	        else if (current.exception || last.exception) {
	            return isSameException(current.exception, last.exception);
	        }
	
	        return true;
	    },
	
	    _setBackoffState: function(request) {
	        // If we are already in a backoff state, don't change anything
	        if (this._shouldBackoff()) {
	            return;
	        }
	
	        var status = request.status;
	
	        // 400 - project_id doesn't exist or some other fatal
	        // 401 - invalid/revoked dsn
	        // 429 - too many requests
	        if (!(status === 400 || status === 401 || status === 429))
	            return;
	
	        var retry;
	        try {
	            // If Retry-After is not in Access-Control-Expose-Headers, most
	            // browsers will throw an exception trying to access it
	            retry = request.getResponseHeader('Retry-After');
	            retry = parseInt(retry, 10) * 1000; // Retry-After is returned in seconds
	        } catch (e) {
	            /* eslint no-empty:0 */
	        }
	
	
	        this._backoffDuration = retry
	            // If Sentry server returned a Retry-After value, use it
	            ? retry
	            // Otherwise, double the last backoff duration (starts at 1 sec)
	            : this._backoffDuration * 2 || 1000;
	
	        this._backoffStart = now();
	    },
	
	    _send: function(data) {
	        var globalOptions = this._globalOptions;
	
	        var baseData = {
	            project: this._globalProject,
	            logger: globalOptions.logger,
	            platform: 'javascript'
	        }, httpData = this._getHttpData();
	
	        if (httpData) {
	            baseData.request = httpData;
	        }
	
	        // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
	        if (data.trimHeadFrames) delete data.trimHeadFrames;
	
	        data = objectMerge(baseData, data);
	
	        // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	        data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	        data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	        // Send along our own collected metadata with extra
	        data.extra['session:duration'] = now() - this._startTime;
	
	        if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	            // intentionally make shallow copy so that additions
	            // to breadcrumbs aren't accidentally sent in this request
	            data.breadcrumbs = {
	                values: [].slice.call(this._breadcrumbs, 0)
	            };
	        }
	
	        // If there are no tags/extra, strip the key from the payload alltogther.
	        if (isEmptyObject(data.tags)) delete data.tags;
	
	        if (this._globalContext.user) {
	            // sentry.interfaces.User
	            data.user = this._globalContext.user;
	        }
	
	        // Include the environment if it's defined in globalOptions
	        if (globalOptions.environment) data.environment = globalOptions.environment;
	
	        // Include the release if it's defined in globalOptions
	        if (globalOptions.release) data.release = globalOptions.release;
	
	        // Include server_name if it's defined in globalOptions
	        if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	        if (isFunction(globalOptions.dataCallback)) {
	            data = globalOptions.dataCallback(data) || data;
	        }
	
	        // Why??????????
	        if (!data || isEmptyObject(data)) {
	            return;
	        }
	
	        // Check if the request should be filtered or not
	        if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
	            return;
	        }
	
	        // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
	        // so drop requests until "cool-off" period has elapsed.
	        if (this._shouldBackoff()) {
	            this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
	            return;
	        }
	
	        this._sendProcessedPayload(data);
	    },
	
	    _getUuid: function () {
	      return uuid4();
	    },
	
	    _sendProcessedPayload: function(data, callback) {
	        var self = this;
	        var globalOptions = this._globalOptions;
	
	        if (!this.isSetup()) return;
	
	        // Send along an event_id if not explicitly passed.
	        // This event_id can be used to reference the error within Sentry itself.
	        // Set lastEventId after we know the error should actually be sent
	        this._lastEventId = data.event_id || (data.event_id = this._getUuid());
	
	        // Try and clean up the packet before sending by truncating long values
	        data = this._trimPacket(data);
	
	        // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
	        // but this would require copying an un-truncated copy of the data packet, which can be
	        // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
	        if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
	            this._logDebug('warn', 'Raven dropped repeat event: ', data);
	            return;
	        }
	
	        // Store outbound payload after trim
	        this._lastData = data;
	
	        this._logDebug('debug', 'Raven about to send:', data);
	
	        var auth = {
	            sentry_version: '7',
	            sentry_client: 'raven-js/' + this.VERSION,
	            sentry_key: this._globalKey
	        };
	        if (this._globalSecret) {
	            auth.sentry_secret = this._globalSecret;
	        }
	
	        var exception = data.exception && data.exception.values[0];
	        this.captureBreadcrumb({
	            category: 'sentry',
	            message: exception
	                ? (exception.type ? exception.type + ': ' : '') + exception.value
	                : data.message,
	            event_id: data.event_id,
	            level: data.level || 'error' // presume error unless specified
	        });
	
	        var url = this._globalEndpoint;
	        (globalOptions.transport || this._makeRequest).call(this, {
	            url: url,
	            auth: auth,
	            data: data,
	            options: globalOptions,
	            onSuccess: function success() {
	                self._resetBackoff();
	
	                self._triggerEvent('success', {
	                    data: data,
	                    src: url
	                });
	                callback && callback();
	            },
	            onError: function failure(error) {
	                self._logDebug('error', 'Raven transport failed to send: ', error);
	
	                if (error.request) {
	                    self._setBackoffState(error.request);
	                }
	
	                self._triggerEvent('failure', {
	                    data: data,
	                    src: url
	                });
	                error = error || new Error('Raven send failed (no additional details provided)');
	                callback && callback(error);
	            }
	        });
	    },
	
	    _makeRequest: function(opts) {
	        var request = new XMLHttpRequest();
	
	        // if browser doesn't support CORS (e.g. IE7), we are out of luck
	        var hasCORS =
	            'withCredentials' in request ||
	            typeof XDomainRequest !== 'undefined';
	
	        if (!hasCORS) return;
	
	        var url = opts.url;
	        function handler() {
	            if (request.status === 200) {
	                if (opts.onSuccess) {
	                    opts.onSuccess();
	                }
	            } else if (opts.onError) {
	                var err = new Error('Sentry error code: ' + request.status);
	                err.request = request;
	                opts.onError(err);
	            }
	        }
	
	        if ('withCredentials' in request) {
	            request.onreadystatechange = function () {
	                if (request.readyState !== 4) {
	                    return;
	                }
	                handler();
	            };
	        } else {
	            request = new XDomainRequest();
	            // xdomainrequest cannot go http -> https (or vice versa),
	            // so always use protocol relative
	            url = url.replace(/^https?:/, '');
	
	            // onreadystatechange not supported by XDomainRequest
	            request.onload = handler;
	        }
	
	        // NOTE: auth is intentionally sent as part of query string (NOT as custom
	        //       HTTP header) so as to avoid preflight CORS requests
	        request.open('POST', url + '?' + urlencode(opts.auth));
	        request.send(stringify(opts.data));
	    },
	
	    _logDebug: function(level) {
	        if (this._originalConsoleMethods[level] && this.debug) {
	            // In IE<10 console methods do not have their own 'apply' method
	            Function.prototype.apply.call(
	                this._originalConsoleMethods[level],
	                this._originalConsole,
	                [].slice.call(arguments, 1)
	            );
	        }
	    },
	
	    _mergeContext: function(key, context) {
	        if (isUndefined(context)) {
	            delete this._globalContext[key];
	        } else {
	            this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	        }
	    }
	};
	
	/*------------------------------------------------
	 * utils
	 *
	 * conditionally exported for test via Raven.utils
	 =================================================
	 */
	var objectPrototype = Object.prototype;
	
	function isUndefined(what) {
	    return what === void 0;
	}
	
	function isFunction(what) {
	    return typeof what === 'function';
	}
	
	function isString(what) {
	    return objectPrototype.toString.call(what) === '[object String]';
	}
	
	function isObject(what) {
	    return typeof what === 'object' && what !== null;
	}
	
	function isEmptyObject(what) {
	    for (var _ in what) return false;  // eslint-disable-line guard-for-in, no-unused-vars
	    return true;
	}
	
	// Sorta yanked from https://github.com/joyent/node/blob/aa3b4b4/lib/util.js#L560
	// with some tiny modifications
	function isError(what) {
	    var toString = objectPrototype.toString.call(what);
	    return isObject(what) &&
	        toString === '[object Error]' ||
	        toString === '[object Exception]' || // Firefox NS_ERROR_FAILURE Exceptions
	        what instanceof Error;
	}
	
	function each(obj, callback) {
	    var i, j;
	
	    if (isUndefined(obj.length)) {
	        for (i in obj) {
	            if (hasKey(obj, i)) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    } else {
	        j = obj.length;
	        if (j) {
	            for (i = 0; i < j; i++) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    }
	}
	
	function objectMerge(obj1, obj2) {
	    if (!obj2) {
	        return obj1;
	    }
	    each(obj2, function(key, value){
	        obj1[key] = value;
	    });
	    return obj1;
	}
	
	function truncate(str, max) {
	    return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	    return objectPrototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	    // Combine an array of regular expressions and strings into one large regexp
	    // Be mad.
	    var sources = [],
	        i = 0, len = patterns.length,
	        pattern;
	
	    for (; i < len; i++) {
	        pattern = patterns[i];
	        if (isString(pattern)) {
	            // If it's a string, we need to escape it
	            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	        } else if (pattern && pattern.source) {
	            // If it's a regexp already, we want to extract the source
	            sources.push(pattern.source);
	        }
	        // Intentionally skip other cases
	    }
	    return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	    var pairs = [];
	    each(o, function(key, value) {
	        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	    });
	    return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) return {};
	
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        protocol: match[2],
	        host: match[4],
	        path: match[5],
	        relative: match[5] + query + fragment // everything minus origin
	    };
	}
	function uuid4() {
	    var crypto = _window.crypto || _window.msCrypto;
	
	    if (!isUndefined(crypto) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	
	        // set 4 in byte 7
	        arr[3] = arr[3] & 0xFFF | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        arr[4] = arr[4] & 0x3FFF | 0x8000;
	
	        var pad = function(num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = '0' + v;
	            }
	            return v;
	        };
	
	        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
	        pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
	    } else {
	        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	            var r = Math.random()*16|0,
	                v = c === 'x' ? r : r&0x3|0x8;
	            return v.toString(16);
	        });
	    }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	    /* eslint no-extra-parens:0*/
	    var MAX_TRAVERSE_HEIGHT = 5,
	        MAX_OUTPUT_LEN = 80,
	        out = [],
	        height = 0,
	        len = 0,
	        separator = ' > ',
	        sepLength = separator.length,
	        nextStr;
	
	    while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	
	        nextStr = htmlElementAsString(elem);
	        // bail out if
	        // - nextStr is the 'html' element
	        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	        //   (ignore this limit if we are on the first iteration)
	        if (nextStr === 'html' || height > 1 && len + (out.length * sepLength) + nextStr.length >= MAX_OUTPUT_LEN) {
	            break;
	        }
	
	        out.push(nextStr);
	
	        len += nextStr.length;
	        elem = elem.parentNode;
	    }
	
	    return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	    var out = [],
	        className,
	        classes,
	        key,
	        attr,
	        i;
	
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	
	    out.push(elem.tagName.toLowerCase());
	    if (elem.id) {
	        out.push('#' + elem.id);
	    }
	
	    className = elem.className;
	    if (className && isString(className)) {
	        classes = className.split(/\s+/);
	        for (i = 0; i < classes.length; i++) {
	            out.push('.' + classes[i]);
	        }
	    }
	    var attrWhitelist = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < attrWhitelist.length; i++) {
	        key = attrWhitelist[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push('[' + key + '="' + attr + '"]');
	        }
	    }
	    return out.join('');
	}
	
	/**
	 * Returns true if either a OR b is truthy, but not both
	 */
	function isOnlyOneTruthy(a, b) {
	    return !!(!!a ^ !!b);
	}
	
	/**
	 * Returns true if the two input exception interfaces have the same content
	 */
	function isSameException(ex1, ex2) {
	    if (isOnlyOneTruthy(ex1, ex2))
	        return false;
	
	    ex1 = ex1.values[0];
	    ex2 = ex2.values[0];
	
	    if (ex1.type !== ex2.type ||
	        ex1.value !== ex2.value)
	        return false;
	
	    return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
	}
	
	/**
	 * Returns true if the two input stack trace interfaces have the same content
	 */
	function isSameStacktrace(stack1, stack2) {
	    if (isOnlyOneTruthy(stack1, stack2))
	        return false;
	
	    var frames1 = stack1.frames;
	    var frames2 = stack2.frames;
	
	    // Exit early if frame count differs
	    if (frames1.length !== frames2.length)
	        return false;
	
	    // Iterate through every frame; bail out if anything differs
	    var a, b;
	    for (var i = 0; i < frames1.length; i++) {
	        a = frames1[i];
	        b = frames2[i];
	        if (a.filename !== b.filename ||
	            a.lineno !== b.lineno ||
	            a.colno !== b.colno ||
	            a['function'] !== b['function'])
	            return false;
	    }
	    return true;
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	    var orig = obj[name];
	    obj[name] = replacement(orig);
	    if (track) {
	        track.push([obj, name, orig]);
	    }
	}
	
	if (typeof __DEV__ !== 'undefined' && __DEV__) {
	    Raven.utils = {
	        isUndefined: isUndefined,
	        isFunction: isFunction,
	        isString: isString,
	        isObject: isObject,
	        isEmptyObject: isEmptyObject,
	        isError: isError,
	        each: each,
	        objectMerge: objectMerge,
	        truncate: truncate,
	        hasKey: hasKey,
	        joinRegExp: joinRegExp,
	        urlencode: urlencode,
	        uuid4: uuid4,
	        htmlTreeAsString: htmlTreeAsString,
	        htmlElementAsString: htmlElementAsString,
	        parseUrl: parseUrl,
	        fill: fill
	    };
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	'use strict';
	
	var RavenConstructor = __webpack_require__(22);
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	var _Raven = _window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function () {
		_window.Raven = _Raven;
		return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 24 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	/*
	 TraceKit - Cross brower stack traces
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	    collectWindowErrors: true,
	    debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
	
	function getLocationHref() {
	    if (typeof document === 'undefined' || typeof document.location === 'undefined')
	        return '';
	
	    return document.location.href;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	          return;
	        }
	        for (var i in handlers) {
	            if (handlers.hasOwnProperty(i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	
	            var name = undefined;
	            var msg = message; // must be new var or will modify original `arguments`
	            var groups;
	            if ({}.toString.call(message) === '[object String]') {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }
	
	            location.func = UNKNOWN_FUNCTION;
	
	            stack = {
	                'name': name,
	                'message': msg,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler ()
	    {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = _window.onerror;
	        _window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    function uninstallGlobalHandler ()
	    {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        _window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }
	
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	              processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, (stack.incomplete ? 2000 : 0));
	
	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}());
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if ((parts = chrome.exec(lines[i]))) {
	                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ( parts = winjs.exec(lines[i]) ) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ((parts = gecko.exec(lines[i]))) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = UNKNOWN_FUNCTION;
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if ((parts = functionName.exec(curr.toString()))) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	              try {
	                item.func = parts.input.substring(0, parts.input.indexOf('{'));
	              } catch (e) { }
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            }else{
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = (depth == null ? 0 : +depth);
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	    return computeStackTrace;
	}());
	
	module.exports = TraceKit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 25 */,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookieUtil = __webpack_require__(29);
	
	var _cookieUtil2 = _interopRequireDefault(_cookieUtil);
	
	var _innerToOuterDto = __webpack_require__(10);
	
	var _innerToOuterDto2 = _interopRequireDefault(_innerToOuterDto);
	
	var _outerDiContainer = __webpack_require__(12);
	
	var _outerDiContainer2 = _interopRequireDefault(_outerDiContainer);
	
	var _environment = __webpack_require__(1);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _outerWidget = __webpack_require__(13);
	
	var _outerWidget2 = _interopRequireDefault(_outerWidget);
	
	var _logger = __webpack_require__(4);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * イベント監視クラス
	 */
	var Monitoring = function () {
	  function Monitoring(diContainer, environment, window, doc) {
	    _classCallCheck(this, Monitoring);
	
	    this.diContainer = diContainer;
	    this.registerResizeWidthEvent(window, doc);
	    this.registerReceivePostMessageEvent(window, doc, environment);
	    this.registerMeasureInviewEvent(window, doc);
	  }
	
	  /**
	   * getInstance
	   * @param diContainer
	   * @param environment
	   * @param window
	   * @param doc
	   * @returns {Monitoring}
	   */
	
	
	  _createClass(Monitoring, [{
	    key: "registerResizeWidthEvent",
	    value: function registerResizeWidthEvent(window, doc) {
	      var _this = this;
	      // リサイズイベントが何もなければイベント監視を行わない
	      if (!_this.diContainer.handleResizeEvent) {
	        return;
	      }
	
	      var resizeWaitTimer = false; // resizeイベントコールバック遅延実行タイマー変数
	
	      var resizeFunction = function resizeFunction() {
	        // 遅延実行タイマーをクリアする
	        if (resizeWaitTimer !== false) {
	          clearTimeout(resizeWaitTimer);
	        }
	        // 遅延実行タイマーを再設定
	        resizeWaitTimer = setTimeout(function () {
	          window.Uzou.widgets.forEach(function (widget) {
	            // resizeWidth関数はwidgetから呼び出してください
	            _this.diContainer.handleResizeEvent(widget, window, doc);
	          });
	        }, 200);
	      };
	
	      if (window.addEventListener) {
	        window.addEventListener('resize', resizeFunction, false);
	      } else if (window.attachEvent) {
	        window.attachEvent('onresize', resizeFunction);
	      }
	    }
	
	    /**
	     * PostMessageイベント監視
	     * @param window
	     * @param doc
	     * @param environment
	     */
	
	  }, {
	    key: "registerReceivePostMessageEvent",
	    value: function registerReceivePostMessageEvent(window, doc, environment) {
	      var receivePostMessageEventFunc = function receivePostMessageEventFunc(messageEvent) {
	        // originが(dev-|staging-| )speee-ad.akamaized.netのみ許可。ローカルの場合はすべて許可
	        if (messageEvent.origin.match(environment.akamaiHost) || environment.isLocal() || environment.isTest()) {
	          try {
	            var dto = _innerToOuterDto2.default.fromStringJson(messageEvent.data); // フレーム内からのメッセージをJson文字列をDtoに変換
	            window.Uzou.widgets.filter(function (widget) {
	              return widget.id === dto.widgetId;
	            }).forEach(function (widget) {
	              widget.receiveDto(dto); // Iframe内から受け取ったデータをwidgetにセット
	              if (widget.user.uuid) {
	                _cookieUtil2.default.saveUUID(widget.user.uuid, doc);
	              }
	              widget.resizeHeight(doc); // iframe内のウィジェットの高さをiframeに設定する
	            });
	          } catch (e) {
	            window.Uzou.logger.error(e);
	          }
	        }
	      };
	
	      if (window.addEventListener) {
	        window.addEventListener('message', receivePostMessageEventFunc, false);
	      } else if (window.attachEvent) {
	        window.attachEvent('onmessage', receivePostMessageEventFunc);
	      }
	    }
	
	    /**
	     * Inviewタイマー監視
	     * @param window
	     * @param doc
	     */
	
	  }, {
	    key: "registerMeasureInviewEvent",
	    value: function registerMeasureInviewEvent(window, doc) {
	      var measureInviewFunc = function measureInviewFunc() {
	        window.Uzou.widgets.forEach(function (widget) {
	          widget.measureInview(window, doc);
	        });
	      };
	
	      // ブラウザタブが非アクティブになった時に一時的にタイマーを停止する IE10以上で対応
	      var hidden = void 0;
	      var visibilityChange = void 0;
	
	      if (typeof document.hidden !== "undefined") {
	        // Opera 12.10 や Firefox 18 以降でサポート
	        hidden = "hidden";
	        visibilityChange = "visibilitychange";
	      } else if (typeof document.mozHidden !== "undefined") {
	        hidden = "mozHidden";
	        visibilityChange = "mozvisibilitychange";
	      } else if (typeof document.msHidden !== "undefined") {
	        hidden = "msHidden";
	        visibilityChange = "msvisibilitychange";
	      } else if (typeof document.webkitHidden !== "undefined") {
	        hidden = "webkitHidden";
	        visibilityChange = "webkitvisibilitychange";
	      }
	
	      var intervalId = false;
	
	      // タブがアクティブの場合計測スタート
	      if (!document[hidden]) {
	        intervalId = setInterval(measureInviewFunc, 1000);
	      }
	
	      if (typeof document.addEventListener !== "undefined" && typeof document[hidden] !== "undefined") {
	        document.addEventListener(visibilityChange, function () {
	          // タブが非アクティブになりタイマーが動いている場合はストップ
	          if (document[hidden] && intervalId) {
	            clearInterval(intervalId);
	            intervalId = false;
	            // タブが再度アクティブに戻った時にタイマーが動いてなければ再始動
	          } else {
	            if (!intervalId) {
	              intervalId = setInterval(measureInviewFunc, 1000);
	            }
	          }
	        }, false);
	      }
	    }
	  }], [{
	    key: "getInstance",
	    value: function getInstance(diContainer, environment, window, doc) {
	      var uzouMonitoring = new Monitoring(diContainer, environment, window, doc);
	      // singleton
	      Monitoring.getInstance = function () {
	        return uzouMonitoring;
	      };
	
	      return uzouMonitoring;
	    }
	  }]);
	
	  return Monitoring;
	}();
	
	exports.default = Monitoring;
	module.exports = exports["default"];

/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * WidgetのStyle系情報を保持
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OuterWidgetAttribute = function () {
	  function OuterWidgetAttribute(height, mediaZoom) {
	    _classCallCheck(this, OuterWidgetAttribute);
	
	    this.height = height;
	    this.mediaZoom = mediaZoom;
	  }
	
	  /**
	   * create
	   * @param window
	   * @param doc
	   * @param iframeParentDiv
	   * @returns {OuterWidgetAttribute}
	   */
	
	
	  _createClass(OuterWidgetAttribute, null, [{
	    key: 'create',
	    value: function create(window, doc, iframeParentDiv) {
	      var heightPx = void 0;
	      var height = void 0;
	      try {
	        if (!window.getComputedStyle) {
	          heightPx = iframeParentDiv.currentStyle['height'];
	        } else {
	          heightPx = window.getComputedStyle(iframeParentDiv).getPropertyValue('height');
	        }
	        height = parseInt(heightPx.replace(/px/, ""));
	      } catch (e) {
	        height = 0;
	      }
	
	      var mediaZoom = function (doc) {
	        try {
	          return +doc.getElementsByTagName('html')[0].style.zoom || 1;
	        } catch (e) {
	          return 1;
	        }
	      }(doc);
	
	      return new OuterWidgetAttribute(height, mediaZoom);
	    }
	  }]);
	
	  return OuterWidgetAttribute;
	}();
	
	exports.default = OuterWidgetAttribute;
	module.exports = exports['default'];

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _monitoring = __webpack_require__(26);
	
	var _monitoring2 = _interopRequireDefault(_monitoring);
	
	var _logger = __webpack_require__(4);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _urlParamUtil = __webpack_require__(18);
	
	var _urlParamUtil2 = _interopRequireDefault(_urlParamUtil);
	
	var _outerWidget = __webpack_require__(13);
	
	var _outerWidget2 = _interopRequireDefault(_outerWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	"use strict";
	
	var UzouGlobal = function () {
	  function UzouGlobal(widgets, monitoring, logger, isRehearsal) {
	    _classCallCheck(this, UzouGlobal);
	
	    this.widgets = widgets;
	    this.monitoring = monitoring;
	    this.logger = logger;
	    this.isRehearsal = isRehearsal;
	  }
	
	  _createClass(UzouGlobal, null, [{
	    key: "getInstance",
	    value: function getInstance(monitoring, logger, window) {
	      var widgets = [];
	      var isRehearsal = _urlParamUtil2.default.isRehearsal(window);
	      var uzouGlobal = new UzouGlobal(widgets, monitoring, logger, isRehearsal);
	      // singleton
	      UzouGlobal.getInstance = function () {
	        return uzouGlobal;
	      };
	
	      return uzouGlobal;
	    }
	  }]);
	
	  return UzouGlobal;
	}();
	
	exports.default = UzouGlobal;
	module.exports = exports["default"];

/***/ },
/* 29 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Cookie関連ユーティリティクラス
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CookieUtil = function () {
	  function CookieUtil() {
	    _classCallCheck(this, CookieUtil);
	  }
	
	  _createClass(CookieUtil, null, [{
	    key: 'KEY_UUID',
	
	
	    /**
	     * UUIDKEY
	     * @returns {string}
	     * @constructor
	     */
	    value: function KEY_UUID() {
	      return '__uuiduz';
	    }
	
	    /**
	     * Cookieに指定したKeyで保存
	     * @param document
	     * @param key
	     * @param value
	     * @param expires
	     * @param path
	     */
	
	  }, {
	    key: 'setCookie',
	    value: function setCookie(document, key, value, expires, path) {
	      if (typeof expires === 'undefined') {
	        expires = new Date();
	        expires.setMilliseconds(expires.getMilliseconds() + 180 * 864e+5); // デフォルトの有効期限は180日。ミリ秒で設定。
	      }
	      path = typeof path === 'undefined' ? '/' : path;
	
	      document.cookie = [key, '=', encodeURIComponent(value), '; expires=' + expires.toUTCString(), // max-ageはIEの一部のバージョンでサポートされていないため、expiresを使用する
	      '; path=' + path].join('');
	    }
	
	    /**
	     * 指定したKeyのCookieを取得
	     * @param document
	     * @param key
	     * @returns {string}
	     */
	
	  }, {
	    key: 'getCookie',
	    value: function getCookie(document, key) {
	      var result = void 0;
	      var cookies = document.cookie ? document.cookie.split('; ') : [];
	      for (var i = 0; i < cookies.length; i++) {
	        var parts = cookies[i].split('=');
	        var value = decodeURIComponent(parts[1]);
	        if (parts[0] == key) {
	          result = value;
	          break;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * UUIDをCookieに保存
	     * @return {void}
	     */
	
	  }, {
	    key: 'saveUUID',
	    value: function saveUUID(uuid, document) {
	      CookieUtil.setCookie(document, CookieUtil.KEY_UUID(), uuid);
	    }
	
	    /**
	     * CookieからUUIDを取得
	     * @return {string}
	     */
	
	  }, {
	    key: 'loadUUID',
	    value: function loadUUID(document) {
	      var uuid = CookieUtil.getCookie(document, CookieUtil.KEY_UUID());
	      return uuid ? uuid : "";
	    }
	  }]);
	
	  return CookieUtil;
	}();
	
	exports.default = CookieUtil;
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * URL関連ユーティリティクラス
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URLUtil = function () {
	  function URLUtil() {
	    _classCallCheck(this, URLUtil);
	  }
	
	  _createClass(URLUtil, null, [{
	    key: 'fixedEncodeURIComponent',
	
	
	    /**
	     * URLエンコード
	     * @return {string}
	     */
	    value: function fixedEncodeURIComponent(urlString) {
	      return encodeURIComponent(urlString).replace(/[!'()*]/g, function (c) {
	        return '%' + c.charCodeAt(0).toString(16);
	      });
	    }
	
	    /**
	     * リファラ取得
	     * speee akamaiの場合はurl=がエンコードされているurl%22%3A%22から&がエンコードされた%22%2C%22までを取得しデコードしたものをリファラとする
	     * @return {string}
	     */
	
	  }, {
	    key: 'getReferer',
	    value: function getReferer(refer, path) {
	      // refererにpathが含まれていたらurl=xxx&の部分を抜き出す
	      if (refer.match(path)) {
	        var matchedArray = refer.match(new RegExp('url%22%3A%22(.+?)%22%2C%22'));
	        if (matchedArray && matchedArray.length > 1) {
	          return decodeURIComponent(matchedArray[1]);
	        }
	      }
	
	      return URLUtil.fixedEncodeURIComponent(refer);
	    }
	
	    /**
	     * 無限スクロール時の記事URLを取得する。
	     * elementから親のDomを遡っていきsearchDomFunctionの条件に一致するElementに達した場合getAttributeFunctionがそのElementから指定した属性の値を取得する
	     * この関数を呼び出すときは必ず呼び出し元でエラーハンドリングしてください
	     * @param element
	     * @param searchElementFunction
	     * @param getAttributeFunction
	     * @returns {string}
	     */
	
	  }, {
	    key: 'getInfiniteScrollArticleURL',
	    value: function getInfiniteScrollArticleURL(element, searchElementFunction, getAttributeFunction) {
	      var parentElement = element.parentNode;
	      while (parentElement) {
	        if (searchElementFunction(parentElement)) {
	          return getAttributeFunction(parentElement);
	        }
	
	        parentElement = parentElement.parentNode;
	      }
	
	      // 一致した条件のelementが存在しなければエラー
	      throw new Error("Not Found InfiniteScrollArticleURL");
	    }
	  }]);
	
	  return URLUtil;
	}();
	
	exports.default = URLUtil;
	module.exports = exports['default'];

/***/ },
/* 31 */,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _domUtil = __webpack_require__(34);
	
	var _domUtil2 = _interopRequireDefault(_domUtil);
	
	var _urlUtil = __webpack_require__(30);
	
	var _urlUtil2 = _interopRequireDefault(_urlUtil);
	
	var _widgetInview = __webpack_require__(9);
	
	var _widgetInview2 = _interopRequireDefault(_widgetInview);
	
	var _outerWidget = __webpack_require__(13);
	
	var _outerWidget2 = _interopRequireDefault(_outerWidget);
	
	var _outerWidgetAttribute = __webpack_require__(27);
	
	var _outerWidgetAttribute2 = _interopRequireDefault(_outerWidgetAttribute);
	
	var _uzouGlobal = __webpack_require__(28);
	
	var _uzouGlobal2 = _interopRequireDefault(_uzouGlobal);
	
	var _placement = __webpack_require__(2);
	
	var _placement2 = _interopRequireDefault(_placement);
	
	var _environment = __webpack_require__(1);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _device = __webpack_require__(5);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _user = __webpack_require__(7);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _outerDiContainer = __webpack_require__(12);
	
	var _outerDiContainer2 = _interopRequireDefault(_outerDiContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ハンドラ
	 * タグが発火した時点でappendIframeが呼ばれる
	 */
	var OuterWidgetHandler = function () {
	  function OuterWidgetHandler() {
	    _classCallCheck(this, OuterWidgetHandler);
	  }
	
	  _createClass(OuterWidgetHandler, null, [{
	    key: "appendIframeElement",
	
	
	    /**
	     * タグ発火時にコール。
	     * iframeを作成して親Divにappendする
	     */
	    value: function appendIframeElement(uzouGlobal, placement, environment, device, user, diContainer, window, doc) {
	      // placement_codeとnyクラスで絞り込みウィジェット操作対象DOMを取得する
	      var notYetClassName = 'uz-ny'; // uzou not yet
	      var alreadyClassName = 'uz-ar'; // uzou already
	      var unExecutedWidgetParents = doc.querySelectorAll("div.uz-" + placement.code + "." + notYetClassName);
	
	      Array.prototype.forEach.call(unExecutedWidgetParents, function (iframeParentDiv) {
	        _domUtil2.default.removeClass(iframeParentDiv, notYetClassName); // uz-nyクラスを除去して実行済みWidgetとする
	        _domUtil2.default.addClass(iframeParentDiv, alreadyClassName); // 実行済みクラスとしてuzo-arクラスを付与
	
	        var url = diContainer.getURLFunction(window, iframeParentDiv); // placementによってURLの取得方法が変わる可能性があるためDIを利用する
	
	        var referrer = _urlUtil2.default.getReferer(doc.referrer, environment.akamaiHost);
	
	        var attribute = _outerWidgetAttribute2.default.create(window, doc, iframeParentDiv);
	
	        var inview = new _widgetInview2.default();
	
	        var widget = _outerWidget2.default.create(placement, environment, device, user, url, referrer, attribute, inview, uzouGlobal.widgets.length);
	
	        _domUtil2.default.addId(iframeParentDiv, widget.id); // widget親Divにidを追加
	
	        uzouGlobal.widgets.push(widget); // グローバル配列にwidgetデータを追加
	
	        var iframe = widget.toIFrameElement(window, doc); // iframe要素を作成
	
	        iframeParentDiv.appendChild(iframe); // 親divにiframe要素をappend
	      });
	    }
	  }]);
	
	  return OuterWidgetHandler;
	}();
	
	exports.default = OuterWidgetHandler;
	module.exports = exports["default"];

/***/ },
/* 33 */,
/* 34 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	* Dom操作ユーティリティクラス
	*/
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DomUtil = function () {
	  function DomUtil() {
	    _classCallCheck(this, DomUtil);
	  }
	
	  _createClass(DomUtil, null, [{
	    key: 'addId',
	
	
	    /**
	     * 指定した要素にIDを付与
	     * @param element dom要素
	     * @param idName 付与するid名
	     * @returns {boolean}
	     */
	    value: function addId(element, idName) {
	      element.id = idName;
	      return true;
	    }
	
	    /**
	     * 指定した要素に{idName}が指定されているかどうか
	     * @param element
	     * @param idName
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'hasId',
	    value: function hasId(element, idName) {
	      var id = element.id;
	      if (!id) {
	        return false;
	      }
	      return id === idName;
	    }
	
	    /**
	     * 指定した要素からclassを付与
	     * @param element
	     * @param className
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'addClass',
	    value: function addClass(element, className) {
	      if (!DomUtil.hasClass(element, className)) {
	        var classArray = element.className.split(' ');
	        classArray.push(className);
	        element.className = classArray.join(' ');
	        return true;
	      }
	
	      return false;
	    }
	
	    /**
	     * 指定した要素にclassが存在しているか判定
	     * @param element
	     * @param className
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'hasClass',
	    value: function hasClass(element, className) {
	      if (!element.className) {
	        return false;
	      }
	      return (' ' + element.className + ' ').replace(/[\n\t]/g, ' ').indexOf(' ' + className + ' ') !== -1;
	    }
	
	    /**
	     * 指定した要素からclassを除去
	     * @param element dom要素
	     * @param className 削除するクラス名
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'removeClass',
	    value: function removeClass(element, className) {
	      if (!element.className) {
	        return false;
	      }
	      var classArray = element.className.split(' ');
	      var index = classArray.indexOf(className);
	      if (index >= 0) {
	        classArray.splice(index, 1);
	        element.className = classArray.join(' ');
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'findChildElementByAttribute',
	    value: function findChildElementByAttribute(parentElement, attribute) {
	      for (var child = parentElement.firstElementChild; child !== null; child = child.nextSibling) {
	        if (child.hasAttribute(attribute)) {
	          return child;
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return DomUtil;
	}();
	
	exports.default = DomUtil;
	module.exports = exports['default'];

/***/ },
/* 35 */,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _constants = __webpack_require__(3);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _logger = __webpack_require__(4);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _device = __webpack_require__(5);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _environment = __webpack_require__(1);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _placement = __webpack_require__(2);
	
	var _placement2 = _interopRequireDefault(_placement);
	
	var _placementSetting = __webpack_require__(6);
	
	var _placementSetting2 = _interopRequireDefault(_placementSetting);
	
	var _user = __webpack_require__(7);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _uzouGlobal = __webpack_require__(28);
	
	var _uzouGlobal2 = _interopRequireDefault(_uzouGlobal);
	
	var _monitoring = __webpack_require__(26);
	
	var _monitoring2 = _interopRequireDefault(_monitoring);
	
	var _outerDiContainer = __webpack_require__(12);
	
	var _outerDiContainer2 = _interopRequireDefault(_outerDiContainer);
	
	var _outerWidgetHandler = __webpack_require__(32);
	
	var _outerWidgetHandler2 = _interopRequireDefault(_outerWidgetHandler);
	
	var _cookieUtil = __webpack_require__(29);
	
	var _cookieUtil2 = _interopRequireDefault(_cookieUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (window, document) {
	  // 外部設定ファイル(./setting/${placement_code}/setting.jsonから値を取得)
	  var placementSetting = _placementSetting2.default.create({ "placement_code": "okwave_pc", "placement_id": 619, "header_text": "こちらの記事もオススメ", "published_at_fmt": "", "environment": "production", "sentryDSN": "https://192ad2356e5d4330aceef03e56efe0a5@sentry.io/103759" });
	
	  var placement = _placement2.default.create(placementSetting.placementId, placementSetting.placementCode);
	
	  var environment = _environment2.default.create(placementSetting.environment);
	
	  // 初回のみloggerを生成
	  var logger = window.Uzou && window.Uzou.logger ? window.Uzou.logger : _logger2.default.getInstance(environment, placementSetting, window);
	
	  try {
	    var device = _device2.default.create(window); // 端末情報作成
	
	    var user = _user2.default.create(_cookieUtil2.default.loadUUID(document)); // ユーザ情報
	
	    // DIコンテナを生成
	    var diContainer = _outerDiContainer2.default.getInstance();
	
	    // ここのコメントは削除しないでください
	    // diContainer = ${__placement_outer_frame_di__}.getInstance();を
	    // diContainer = require("./placement/${placement.code}/${placement.code}-outer-frame.js").getInstance();で置換する
	    diContainer = __webpack_require__(37).getInstance();
	
	    // 初回のみ生成
	    var uzouGlobal = function () {
	      if (window.Uzou) {
	        return window.Uzou;
	      }
	      var monitoring = _monitoring2.default.getInstance(diContainer, environment, window, document);
	
	      var uzouGlobal = _uzouGlobal2.default.getInstance(monitoring, logger, window);
	
	      window.Uzou = uzouGlobal;
	
	      return uzouGlobal;
	    }();
	
	    // ウィジェット表示開始
	    _outerWidgetHandler2.default.appendIframeElement(uzouGlobal, placement, environment, device, user, diContainer, window, document);
	  } catch (e) {
	    logger.error(e);
	  }
	  // TODO 後々ログ送信が出来るようになったらタグ発火ログを送りたい
	  // finally {
	  //
	  // }
	})(window, document);

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _outerDiContainer = __webpack_require__(12);
	
	var _outerDiContainer2 = _interopRequireDefault(_outerDiContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OuterOkwave_pcDIContainer = function (_OuterDIContainer) {
	  _inherits(OuterOkwave_pcDIContainer, _OuterDIContainer);
	
	  function OuterOkwave_pcDIContainer() {
	    _classCallCheck(this, OuterOkwave_pcDIContainer);
	
	    return _possibleConstructorReturn(this, (OuterOkwave_pcDIContainer.__proto__ || Object.getPrototypeOf(OuterOkwave_pcDIContainer)).call(this));
	  }
	
	  _createClass(OuterOkwave_pcDIContainer, null, [{
	    key: "getInstance",
	    value: function getInstance() {
	      var container = new OuterOkwave_pcDIContainer();
	      OuterOkwave_pcDIContainer.getInstance = function () {
	        return container;
	      };
	
	      return container;
	    }
	
	    /**
	     * iframeParentDivはMediaに貼られるタグのDiv
	     */
	    // getURLFunction(window: Window, iframeParentDiv: HTMLElement): string{
	    //   import URLUtil from "../../util/url-util";
	    //   return URLUtil.fixedEncodeURIComponent(window.location.href);
	    // };
	
	  }]);
	
	  return OuterOkwave_pcDIContainer;
	}(_outerDiContainer2.default);
	
	exports.default = OuterOkwave_pcDIContainer;
	module.exports = exports["default"];

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// outer-frame.min.js